import React from 'react';
import { Empty } from 'antd';
import { StyledTable } from './Styles';

const Table = (props) => {
  return (
    <StyledTable
      locale={{
        emptyText: <Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
      }}
      {...props}
    />
  );
};

export default Table;
